import { DefaultPage } from './index';

export default {
  path: '/',
  name: 'Home',
  component: DefaultPage,
  isPrivate: true,
};
